export const RELATIONSHIP_DATA_LOAD_LIMIT = 15;
